module.exports = __webpack_public_path__ + "img/Anny.58727c43.jpg";